const isProduction = process.env.REACT_APP_DEBUG_CONSOLE_ENABLED || false
if (!isProduction) {
       console.log = function () { };
       console.debug = function () { };
       console.error = function () { };
       console.warn = function () { };
       console.info = function () { };
}
